import React, { useState } from "react";
import RunbookOverview from "./RunbookOverview";
import RunbookExecutionsList from "./RunbookExecutionsList";
import ExecutionDetail from "./ExecutionDetail";

function RunbookExecutionsTab(props) {
  const [view, setView] = useState("overview"); // "overview", "executions", "detail"
  const [selectedRunbook, setSelectedRunbook] = useState(null);
  const [selectedExecution, setSelectedExecution] = useState(null);

  const handleRunbookClick = (runbook) => {
    setSelectedRunbook(runbook);
    setView("executions");
  };

  const handleExecutionClick = (execution) => {
    setSelectedExecution(execution);
    setView("detail");
  };

  const handleBackToOverview = () => {
    setView("overview");
    setSelectedRunbook(null);
    setSelectedExecution(null);
  };

  const handleBackToExecutions = () => {
    setView("executions");
    setSelectedExecution(null);
  };

  return (
    <div>
      {view === "overview" && (
        <RunbookOverview
          user={props.user}
          dateRange={props.dateRange}
          clientId={props.clientId}
          onRunbookClick={handleRunbookClick}
        />
      )}

      {view === "executions" && (
        <RunbookExecutionsList
          user={props.user}
          dateRange={props.dateRange}
          clientId={props.clientId}
          runbook={selectedRunbook}
          onExecutionClick={handleExecutionClick}
          onBack={handleBackToOverview}
        />
      )}

      {view === "detail" && (
        <ExecutionDetail
          user={props.user}
          clientId={props.clientId}
          execution={selectedExecution}
          onBack={handleBackToExecutions}
        />
      )}
    </div>
  );
}

export default RunbookExecutionsTab;
